import type { Theme } from '@mui/material/styles';

export const BUBBLE_BORDER_RADIUS = 0.5;
export const BUBBLE_TAIL_SIZE = 1;
export const bgColor = (theme: Theme, isUserMessage: boolean) =>
  isUserMessage ? theme.palette.primary.light : theme.palette.background.boxDark;

export const MESSAGE_FONT_SIZE = 15;
